import {serverDomain} from "../constants";
import {Config, configSchema, ClientKeycloakConfig, clientKeycloakConfigSchema} from "sharedlibs";
import KeycloakService from "../KeycloakService";

/**
 * Fetches the config from the server
 */
export async function getConfig(): Promise<Config> {
  const token = KeycloakService.instance.getToken()
  const response = await fetch(`${serverDomain}/config`, {
    method: 'GET',
    headers: {
      "Authorization": `Bearer ${token}`
    }
  })
  if (!response.ok) {
    throw new Error(`Could not fetch config! HTTP status: ${response.status}`);
  }
  const json = await response.json()
  return configSchema.parse(json)
}

/**
 * Updates the config on the server and returns the config as the server stored it.
 * Throws only when the save failed.
 * @param config
 */
export async function updateConfig(config: Config): Promise<Config> {
  const token = KeycloakService.instance.getToken()
  const response = await fetch(`${serverDomain}/config`, {
    method: 'POST',
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(config)
  })

  if (!response.ok) {
    throw new Error(`Could not update config! HTTP status: ${response.status}`);
  }

  // The config is saved at this point, so an answer that cannot be read must not
  // turn the save into a failure. The server stores the config it was sent, so
  // that config, parsed with the same schema, is then the stored one.
  try {
    return configSchema.parse(await response.json())
  } catch (e) {
    console.error('Config saved, but the stored config in the answer could not be read:', e)
    return configSchema.parse(config)
  }
}

export async function getKeycloakConfig(): Promise<ClientKeycloakConfig> {
  const cachedConfig = sessionStorage.getItem("keycloakConfig")

  if (cachedConfig) {
    return JSON.parse(cachedConfig)
  }

  const response = await fetch(`${serverDomain}/clientconfig/keycloak`, {
    method: 'GET',
  })
  const config = await response.json()
  const parsedConfig = clientKeycloakConfigSchema.parse(config)
  sessionStorage.setItem("keycloakConfig", JSON.stringify(parsedConfig));
  return parsedConfig
}
